// src/app/screens/UnjustifiedAbsence/UnjustifiedAbsenceShow.js
import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { ButtonTooltip, Icon } from '../../components';

const UnjustifiedAbsenceShow = ({ unjustifiedAbsence }) => {
  const { employee, date, reason, fileInfo } = unjustifiedAbsence || {};
  const fullName = employee?.fullName || '';

  return (
    <Form className="px-5">
      <Row>
        <Col xs={12} md={4}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Nombre:</span>
            <span className="answer">{fullName}</span>
          </div>
        </Col>
        <Col xs={12} md={4}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Fecha:</span>
            <span className="answer">{date}</span>
          </div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={12}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Motivo:</span>
            <span className="answer">{reason}</span>
          </div>
        </Col>
      </Row>
      <Row xs="auto">
        {fileInfo && Object.keys(fileInfo).length > 0 && (
          <>
            <Col xs={1}>
              <ButtonTooltip
                onClick={() => window.open(fileInfo.fileUrl, '_blank', 'noopener', 'noreferrer')}
                variant="circle-primary"
                className="btn-circle mx-0"
                text="Descargar"
              >
                <Icon icon="download-2" height="16px" width="16px" />
              </ButtonTooltip>
            </Col>
            <Col xs={6} className="d-flex align-items-center">
              <p className="mb-0">Descargar Documento Adjunto</p>
            </Col>
          </>
        )}
      </Row>
    </Form>
  );
};

export default UnjustifiedAbsenceShow;
